import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from '@/auth/AuthProvider';
import { RequirePin } from '@/auth/RequirePin';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('HOTTR.me root element missing');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <RequirePin>
          <App />
        </RequirePin>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
